// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1fLUR","requiredAsterisk":"Info_requiredAsterisk__2uhSA"};